import React, { FC, memo } from 'react';
import ImageViewer from 'udesk-react/src/components/image-viewer';

const ToolbarDefault = {
    zoomIn: true,
    zoomOut: true,
    oneToOne: true,
    reset: true,
    prev: false,
    play: {
        show: true,
        size: 'large',
    },
    next: false,
    rotateLeft: true,
    rotateRight: true,
    flipHorizontal: true,
    flipVertical: true,
};

interface TemplateProps {
    [key: string]: any;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { children, ...restProps } = props;

    return (
        <ImageViewer
            toolbar={{
                ...ToolbarDefault,
            }}
            {...restProps}
        >
            {children}
        </ImageViewer>
    );
});

export default Template;
